import { InteractiveRulerTool } from '@cadstrom/renderer';
import StraightenIcon from '@mui/icons-material/Straighten';

import { DrawingManagerContext } from '../context/drawing-manager-context.js';
import { ToolbarItem } from './toolbar-item.js';

import type { IRulerMarkInterval } from '@cadstrom/renderer';
import type { ElementType } from 'react';
import type { DrawingManagerContextValue } from '../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState } from './toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

const RulerMarkIntervals: IRulerMarkInterval[] = [
	{
		interval: 1,
		markLength: 10,
		markWidth: 2,
	},
	{
		interval: 5,
		markLength: 20,
		markWidth: 2,
	},
	{
		interval: 10,
		markLength: 40,
		markWidth: 2,
		renderLabel: true,
	},
];

export class MeasureToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'measure';
	private ruler?: InteractiveRulerTool;

	id: string = MeasureToolbarItem.ItemId;
	title = 'Measure';
	keyEventName = 'MEASURE';
	defaultKeyBinding = 'm';
	iconElement: ElementType = StraightenIcon;
	includeInHistory = true;
	isExclusive = true;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;

	public override componentDidMount(): void {
		if (super.componentDidMount) {
			super.componentDidMount();
		}

		this.onActiveStateChanged(this.props.active);
	}

	public onActiveStateChanged(isActive: boolean) {
		if (isActive) {
			this.initRuler();
		} else if (this.ruler) {
			this.context?.drawingManager?.removeInteractiveElement(this.ruler);
			this.ruler.removeAllListeners();
			this.ruler.destroy();
			delete this.ruler;
		}
	}

	private initRuler() {
		if (this.context?.drawingManager) {
			if (!this.ruler) {
				this.ruler = new InteractiveRulerTool(
					this.context.drawingManager,
					this.context.drawingManager.colorProvider,
					RulerMarkIntervals,
				);

				this.ruler.on('rulerUpdated', this.rulerUpdated);
			}

			this.context.drawingManager.addInteractiveElement(this.ruler);
		}
	}

	private readonly rulerUpdated = (ruler: InteractiveRulerTool) => {
		if (ruler.hasSelection) {
			this.emitToolUsed(ruler.drawingCoords());
		}
	};

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}

	public override componentWillUnmount(): void {
		if (this.ruler) {
			this.ruler.destroy();
			delete this.ruler;
		}

		super.componentWillUnmount();
	}
}

MeasureToolbarItem.contextType = DrawingManagerContext;
